<template>

    <div class="col-10 mx-auto p-3">

        <h1 class="text-center" style="font-size: 1.5rem !important;">Course Exit Data</h1>

        <!-- Programme selector -->
        <div class="mb-3">
            <label for="">Choose Programme</label>
            <select
                v-model="selectedProgrammeId"
                class="form-control"
                @change="fetchCourseExitData"
            >
                <option :value="null" disabled>Select Programme</option>
                <option v-for="p in programmes" :key="p.id" :value="p.id">{{ p.name }}</option>
            </select>
        </div>

        <div v-if="tableGroups">

            <h5 class="text-center font-weight-bold mb-3">{{ tableGroups.programName }}</h5>

            <div v-for="group in tableGroups.subgroups" :key="group.key" class="mb-4">

                <h6 class="table-secondary font-weight-bold text-center p-4 mb-0">{{ group.label }}</h6>

                <table class="table table-bordered mb-0">
                    <thead class="thead-dark text-left">
                        <tr>
                            <th style="width: 80px; border: 1px solid white;">SI. No.</th>
                            <th style="border: 1px solid white;">Course Name</th>
                            <th style="border: 1px solid white;">Name of Course Exit Survey</th>
                            <th style="width: 160px; border: 1px solid white;">Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in group.rows" :key="row.key">
                            <td v-if="row.isFirst" :rowspan="row.rowspan" class="align-middle">{{ row.siNo }}</td>
                            <td v-if="row.isFirst" :rowspan="row.rowspan" class="align-middle">{{ row.courseName }}</td>
                            <td :class="{ 'text-danger': row.noSurvey }">{{ row.surveyLabel }}</td>
                            <td>{{ row.createdAt }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: "CourseExitData",
    props: {
        lazy: { type: Boolean, default: false }
    },
    data() {
        return {
            programmes: [],
            selectedProgrammeId: null,
            courseExitData: null,
        }
    },
    computed: {
        tableGroups() {
            if (!this.courseExitData || !this.courseExitData.usersubgroups) return null;

            const subgroups = [];

            for (const sub of this.courseExitData.usersubgroups) {
                let siNo = 1;
                const rows = [];

                for (const course of (sub.courses || [])) {
                    const surveys = course.surveys || [];
                    if (surveys.length > 0) {
                        surveys.forEach((survey, i) => {
                            rows.push({
                                key: `${course.id}-${survey.id}`,
                                isFirst: i === 0,
                                rowspan: surveys.length,
                                siNo: i === 0 ? siNo : null,
                                courseName: course.name,
                                surveyLabel: survey.name,
                                createdAt: this.formatDate(survey.created_at),
                            });
                        });
                        siNo++;
                    } else {
                        rows.push({
                            key: `${course.id}-none`,
                            isFirst: true,
                            rowspan: 1,
                            siNo: siNo++,
                            courseName: course.name,
                            surveyLabel: 'No Survey Created',
                            noSurvey: true,
                            createdAt: '',
                        });
                    }
                }

                subgroups.push({ key: `sub-${sub.id}`, label: sub.name, rows });
            }

            return { programName: this.courseExitData.name, subgroups };
        }
    },
    mounted() {
        this.fetchProgrammes();
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return '-';
            const d = new Date(dateStr);
            return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        },
        async fetchProgrammes() {
            const url = this.$store.getters.getAPIKey.mainAPI + "/usergroups/allusergroups?subgroup_types_status=1";
            await this.$axios.get(url)
                .then((response) => {
                    this.programmes = response.data;
                    if (this.programmes.length > 0) {
                        this.selectedProgrammeId = this.programmes[0].id;
                        this.fetchCourseExitData();
                    }
                })
                .catch((error) => {
                    error;
                });
        },
        async fetchCourseExitData() {
            if (!this.selectedProgrammeId) return;
            this.courseExitData = null;
            const url = this.$store.getters.getAPIKey.mainAPI + `/analytics/course-exit-data/${this.selectedProgrammeId}`;
            await this.$axios.get(url)
                .then((response) => {
                    this.courseExitData = response.data;
                })
                .catch((error) => {
                    error;
                });
        }
    }
}
</script>
